module.exports = __webpack_public_path__ + "static/media/TradeGothicLTStd-Cn18.90c5331a.otf";